<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <v-card class="coming-soon-modal">
      <v-card-title>
        <h2 class="font card-title">¡Importante!</h2>
      </v-card-title>
      <v-card-text class="font card-text">
        ¿Deseas abandonar la organización?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onCancel()">Cancelar</v-btn>
        <v-btn color="primary" text @click="onContinue()">Abandonar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { DISCONNECT_USER_FROM_ORGANIZATION_MUTATION, DISCONNECT_ORGANIZATION_FROM_USER_MUTATION } from '../../constants/graphql';
  export default {
    data () {
      return {
      };
    },
    props: {
      dialog: {
        type: Boolean,
        default: false
      },
      user: {
        type: Object,
        default: {}
      },
      organizationId: {
        type: Number
      }
    },
    computed: {
    },
    watch: {
      dialog (val) {
        this.$emit('update:dialog', !!val);
      }
    },
    methods: {
      onCancel () {
        this.$emit('update:dialog', false);
      },
      onContinue () {
        this.$apollo.mutate({
          mutation: DISCONNECT_USER_FROM_ORGANIZATION_MUTATION,
          variables: {
            userId: this.user.id,
            orgId: this.organizationId
          }
        }).then(() => {
          this.$apollo.mutate({
            mutation: DISCONNECT_ORGANIZATION_FROM_USER_MUTATION,
            variables: {
              userId: this.user.id,
              orgId: this.organizationId
            }
          }).then(() => {
            this.$emit('leave-org-event');
          }).catch(() => {
          });
        }).catch(() => {
        });
        this.$emit('update:dialog', false);
      }
    }
  };
</script>


// WEBPACK FOOTER //
// LeaveOrganizationModal.vue?314fb8c3